// extracted by mini-css-extract-plugin
module.exports = {"viewVideoButton":"ViewVideoButton_viewVideoButton__AmaSf","viewVideoModal":"ViewVideoButton_viewVideoModal__bnKjD"};